// extracted by mini-css-extract-plugin
export default {"HowToPlayPop":"HowToPlay_HowToPlayPop__AEI0m"};